// src/pages/Transparencia.js
import React, { useState } from 'react';
import { Accordion, Container, Button, Form } from 'react-bootstrap';
import { FaFileAlt } from 'react-icons/fa';

const documentos = [
  { titulo: 'ESTATUTO SOCIAL', anos: { '2025': '/docs/ESTATUTO SOCIAL CAP 1.pdf'} },
  { titulo: 'ASSEMBLEIA', anos: { '2025': '/docs/ASSEMBLEIA GERAL ORDINARIA RECONHECIADA.pdf', '2026': '/docs/CamScanner 29-10-2026 11.46.pdf' } },
  { titulo: 'EDITAIS', anos: { '2025': '/docs/EDITAL ASSEMBLEIA GERAL ORDINARIA.pdf', '2026': '/docs/01-AAPD_AGO_2026_assinado.pdf' } },
  { titulo: 'PUBLICAÇÕES', anos: { '2025': '/docs/PUBLICACOES.pdf' } },
  { titulo: 'ELEIÇÕES', anos: { '2025': '/docs/ELEICOES.pdf' } },
  { titulo: 'LISTA DE PRESENÇA ASSEMBLEIA', anos: { '2025': '/docs/LISTA DE PRESENCA ASSEMBLRIA GERAL ORDINARIA.pdf', '2026': '/docs/ATA DA ASSEMBLEIA GERAL 2025 A 2028.pdf' } },
  { titulo: 'MEMBROS DIRETORIA', anos: { '2025': '/docs/RELACAO MEMBROS DIRETORIA.pdf' } },
  { titulo: 'OFICIO', anos: { '2026': '/docs/OFICIO 07 2026.pdf' } },
  { titulo: 'RELATÓRIO DE GESTÃO', anos: { '2026': '/docs/CamScanner 21-08-2026 15.21.pdf' } },
  
];

function Transparencia() {
  const [anosSelecionados, setAnosSelecionados] = useState({});

  const handleChangeAno = (titulo, ano) => {
    setAnosSelecionados((prev) => ({ ...prev, [titulo]: ano }));
  };

  const handleAbrirPdf = (titulo) => {
    const anoSelecionado = anosSelecionados[titulo];
    const doc = documentos.find((d) => d.titulo === titulo);
    if (doc && doc.anos[anoSelecionado]) {
      window.open(doc.anos[anoSelecionado], '_blank');
    }
  };

  return (
    <div
      style={{
        background: 'linear-gradient(to right, #f8f9fa, #e0eafc)',
        minHeight: '100vh',
        paddingTop: '40px',
        paddingBottom: '60px',
      }}
    >
      <Container>
        <h2
          className="text-center mb-5"
          style={{
            fontWeight: 'bold',
            color: 'black',
            fontSize: '2.5rem',
            letterSpacing: '1px',
          }}
        >
          Transparência
        </h2>

        <Accordion flush>
          {documentos.map((doc, index) => (
            <Accordion.Item
              key={index}
              eventKey={index.toString()}
              style={{
                border: 'none',
                borderRadius: '12px',
                marginBottom: '20px',
                background: '#fff',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
              }}
            >
              <Accordion.Header
                style={{
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  padding: '15px 20px',
                  backgroundColor: '#f0f4ff',
                  color: '#0d6efd',
                }}
              >
                <FaFileAlt className="me-2 text-primary" /> {doc.titulo}
              </Accordion.Header>

              <Accordion.Body style={{ padding: '20px 30px' }}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: 'bold' }}>Selecione o ano:</Form.Label>
                  <Form.Select
                    value={anosSelecionados[doc.titulo] || ''}
                    onChange={(e) => handleChangeAno(doc.titulo, e.target.value)}
                    style={{ maxWidth: '300px' }}
                  >
                    <option value="">-- Escolha o ano --</option>
                    {Object.keys(doc.anos).map((ano) => (
                      <option key={ano} value={ano}>
                        {ano}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Button
                  variant="outline-primary"
                  disabled={!anosSelecionados[doc.titulo]}
                  onClick={() => handleAbrirPdf(doc.titulo)}
                >
                  📄 Abrir Documento
                </Button>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
}

export default Transparencia;
